// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__j_cro","imageWrap":"Hero_imageWrap__9LCKM","image":"Hero_image___iSqh","gradient":"Hero_gradient__EtkL4","hiddenHeroText":"Hero_hiddenHeroText__CThp_"};